import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';

import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { credentialsInterceptor } from '@core/interceptors';
import { APIRouteMap, appInitializer } from '@core/utils';
import { environment } from '@environment';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  ajaxHeaderInterceptor,
  baseUrlInterceptor,
} from '@paypoint-frontend/web-core';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([
        baseUrlInterceptor(environment),
        credentialsInterceptor(),
        ajaxHeaderInterceptor(),
      ]),
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: `${APIRouteMap.CONTENT_GETTRANSLATES}/`,
        suffix: '',
      }),
    }),
    provideAppInitializer(appInitializer),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'dd.MM.yyyy HH:mm:ss' },
    },
  ],
};
